import React from 'react';
import './WhyPartnerWithUs.css';

const WhyPartnerWithUs = () => {
  const reasons = [
    {
      title: 'Data-Driven Decisions',
      description: 'We make decisions backed by data—not vibes.'
    },
    {
      title: 'Creative-First Storytelling',
      description: 'Our storytelling? Always creative-first, never copy-paste.'
    },
    {
      title: 'Lightning-Fast Delivery',
      description: 'Fast delivery because your momentum matters.'
    },
    {
      title: 'Transparent Pricing',
      description: "Pricing that's transparent, predictable, and fair."
    },
    {
      title: 'Young Team, Strong Ethics',
      description: 'A young team with old-school work ethics + future-proof execution.'
    },
    {
      title: 'Real-Time Communication',
      description: 'Real-time communication, dedicated support — no ghosting, ever.'
    }
  ];

  return (
    <section id="why-partner" className="why-partner">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Why Partner With Us?</h2>
        </div>

        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <div key={index} className="reason-card">
              <div className="reason-number">{String(index + 1).padStart(2, '0')}</div>
              <h3 className="reason-title">{reason.title}</h3>
              <p className="reason-description">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyPartnerWithUs;

